// No-operation function

const noop = () => {
  // nothing here
};

export default noop;
